import { Input } from 'antd';
import dynamic from 'next/dynamic';
import { type ChangeEvent, memo, useCallback } from 'react';

import '~/shared/components/form-fields/captcha-field/captcha-field.scss';

import refreshIcon from '../../../../assets/refresh.svg';

const ClientCaptcha = dynamic(() => import('./react-client-captcha'), {
  ssr: false,
});

type CaptchaFieldConfig = Readonly<{
  getCode?: (code: string) => void;
}>;

type CaptchaFieldPropsType = Readonly<{
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  config?: CaptchaFieldConfig;
  isAutoFocus?: boolean;
  error?: string;
}>;

const CaptchaField = ({ name, onChange, value = '', config, isAutoFocus = false }: CaptchaFieldPropsType) => {
  const handleCaptchaCode = useCallback(
    (newCode: string) => {
      config?.getCode?.(newCode);
    },
    [config],
  );

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.value);
    },
    [onChange],
  );

  return (
    <div className="captcha-field">
      <div className="captcha-field__captcha">
        <ClientCaptcha
          width={140}
          height={70}
          retryIcon={refreshIcon?.src}
          charsCount={6}
          captchaCode={handleCaptchaCode}
        />
      </div>

      <Input
        name={name}
        value={value}
        onChange={handleInputChange}
        type="text"
        autoFocus={isAutoFocus}
        variant="outlined"
      />
    </div>
  );
};

export default memo(CaptchaField);
